(function () {
  var STOCK_RE = /in stock|grab it before|left in stock|skip the 12-week/i;

  function hideAll(sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
  }

  function hideMatching(sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (STOCK_RE.test(el.textContent || '')) el.style.display = 'none';
    });
  }

  /* 2026-10-06: the theme editor used to force the sold-out panel onto EVERY
     product preview (designMode counted as sold), which hid the price, Add to
     cart, callback row and sticky bar in the editor and made mobile audits of
     the buy box impossible. Now the editor shows the real state; to style the
     panel in the editor, click the "KD Sold-out panel" section in the sidebar
     (shopify:section:select) or add ?kd-soldout-preview to the URL. */
  function boot(force) {
    var root = document.querySelector('[data-kd-soldout-root]');
    if (!root) return;

    var forced = (location.search + location.hash).indexOf('kd-soldout-preview') !== -1 || force === true;
    var sold = root.getAttribute('data-sold') === 'true' || forced;
    if (!sold) return;

    // Place the panel high in the buy column: directly above the price block,
    // so it is the first thing read after the product title.
    var buy = document.querySelector('.pdp .buy');
    var price = document.querySelector('.pdp .buy .priceblk');
    var form = document.getElementById('kd-pdp-form');

    if (buy && price && price.parentNode === buy) {
      buy.insertBefore(root, price);
    } else if (buy && form && form.parentNode === buy) {
      buy.insertBefore(root, form);
    } else if (buy) {
      buy.insertBefore(root, buy.firstChild);
    }
    root.hidden = false;

    // Buy controls.
    hideAll('#kd-pdp-form');
    hideAll('.kd-callback-row');
    hideAll('.scarce-strip');
    hideAll('.pdp-sticky');
    hideAll('.price-pay');

    // Stale in-stock claims elsewhere on the page.
    hideMatching('.trustbar-row .tb');
    hideMatching('[id*="kd_pdp_compare"] li');

    document.documentElement.setAttribute('data-kd-sold', 'true');
  }

  function run() { boot(false); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', run);

  // Theme editor: selecting the Sold-out panel section previews it on this product.
  document.addEventListener('shopify:section:select', function (e) {
    var sec = e && e.target;
    if (sec && sec.querySelector && sec.querySelector('[data-kd-soldout-root]')) boot(true);
  });
})();
